import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { SchemaExplorerEntryPointProps } from '@databox/ember-integrations/lib/components/Datasets/SchemaExplorerLink/SchemaExplorerEntryPoint';
import SchemaExplorerEntryPoint from '@databox/ember-integrations/lib/components/Datasets/SchemaExplorerLink/SchemaExplorerEntryPoint';

import type { ReactIntegrations, Service } from 'webapp-types';

import didInsert from 'webapp/modifiers/did-insert';
import didUpdate from 'webapp/modifiers/did-update';
import willDestroy from 'webapp/modifiers/will-destroy';

interface Args {
	dataSourceTypeName?: string;
	origin: string;
}

export default class SchemaExplorerComponent extends Component<Args> {
	@service('navigation') declare navigationService: Service.Navigation;
	@service('dataset-events') declare datasetEventsService: Service.DatasetEvents;
	@service('react') declare reactService: Service.React;

	node: HTMLDivElement | null = null;
	reactElement: ReactIntegrations.Root = null;
	invalidatedGetMetricQuery: (() => void) | null = null;

	@action
	setupView(node: HTMLElement) {
		this.node = node as HTMLDivElement;
		this.reactElement = this.reactService.create(this.node);

		this.renderReactComponent();
	}

	renderReactComponent() {
		const props: SchemaExplorerEntryPointProps = {
			dataSourceTypeName: this.args.dataSourceTypeName,
			origin: this.args.origin,
			isDarkThemeActive: this.navigationService.theme.isDark,
			baseUrl: this.datasetEventsService.datasetsSchemaExplorerUrl,
		};

		if (this.reactElement) {
			this.reactService.render(this.reactElement, SchemaExplorerEntryPoint(props), 'open');
		}
	}

	@action
	updateReactComponent(): void {
		this.renderReactComponent();
	}

	@action
	teardownView() {
		this.reactService.unmount(this.reactElement);
	}
	<template>
		<div
			{{didInsert this.setupView}}
			{{willDestroy this.teardownView}}
			{{didUpdate this.updateReactComponent}}
		/>
	</template>
}
